import "./colunista.css";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../constants/api.js";




function ColunistaPosts(){
    const { id_colunista} = useParams();
    const [posts, setPosts] = useState([]);

     useEffect(() => {
    async function fetchPosts() {
      try {
        const response = await api.get(`/colunistas/${id_colunista}/posts`);
        setPosts(response.data);
        console.log(response.data)

        console.log("Buscando posts do colunista:", id_colunista);
      } catch (error) {
        console.error("Erro ao carregar posts do colunista:", error);
      }
    }

    fetchPosts();
  }, [id_colunista]); // executa sempre que id_colunista mudar

function formatarData(data) {
  return new Date(data).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}



    return <div className="container-posts-colunistas">
        {posts.length > 0 ? (
  posts.map(post => (
    <div className="post-colunistas" key={post.id_post_colunista}>
      <h2>{post.titulo}</h2>

      {post.foto && <img src={post.foto} alt={post.titulo} />}

      <p>{post.texto}</p>

      {/* ASSINATURA + DATA */}
      <div className="post-colunista-footer">
        <p className="assinatura">Por {post.nome_colunista}</p>

        {post.created_at && (
          <p className="data">
            {formatarData(post.created_at)}
          </p>
        )}
      </div>
    </div>
  ))
    ) : (
      <p>Nenhum post encontrado</p>
      )}

    </div>
}


export default ColunistaPosts